import React,{useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAuth} from '../context/AuthContext';
import {useTheme,T} from '../context/ThemeContext';
import api from '../services/api';

export default function ProfilePage(){
  const {user,setUser}=useAuth();
  const {dark,setDark,lang,setLang}=useTheme();
  const theme=dark?{bg:'#0f1729',card:'#1a2744',border:'#2d3f5e',text:'#e2e8f0',subtext:'#93c5fd',inputBg:'#0f1729',cardText:'#fff',tagSite:['#1e40af','#3b82f6']}:{bg:'#f0f4f8',card:'#fff',border:'#d1dde8',text:'#1e293b',subtext:'#64748b',inputBg:'#f8fafc',cardText:'#1e293b',tagSite:['#1e40af','#93c5fd']};
  const t=T[lang];
  const navigate=useNavigate();
  const [form,setForm]=useState({full_name:user?.full_name||'',phone:user?.phone||''});
  const [pwForm,setPwForm]=useState({current_password:'',new_password:'',confirm:''});
  const [msg,setMsg]=useState('');
  const [err,setErr]=useState('');
  const [pwMsg,setPwMsg]=useState('');
  const [pwErr,setPwErr]=useState('');
  const [loading,setLoading]=useState(false);

  const S={
    page:{minHeight:'100vh',background:theme.bg,color:theme.text,fontFamily:'Heebo,sans-serif',direction:lang==='he'?'rtl':'ltr'},
    card:{background:theme.card,borderRadius:16,padding:'28px 32px',marginBottom:24,boxShadow:'0 2px 12px rgba(0,0,0,0.08)'},
    label:{fontSize:13,color:theme.subtext,marginBottom:4,display:'block'},
    input:{width:'100%',padding:'10px 14px',borderRadius:8,border:`1px solid ${theme.border}`,background:theme.inputBg,color:theme.text,fontSize:15,boxSizing:'border-box'},
    btn:{padding:'10px 28px',borderRadius:8,border:'none',cursor:'pointer',fontSize:15,fontWeight:600},
    saveBtn:{background:'#2563eb',color:'#fff'},
    cancelBtn:{background:'transparent',color:theme.subtext,border:`1px solid ${theme.border}`},
    success:{color:'#16a34a',fontSize:14,marginTop:8},
    error:{color:'#dc2626',fontSize:14,marginTop:8},
    badge:{background:theme.tagSite[0],border:`1px solid ${theme.tagSite[1]}`,borderRadius:12,padding:'2px 12px',fontSize:12,color:'#fff'},
  };

  const saveProfile=async()=>{
    setLoading(true);setMsg('');setErr('');
    try{
      const d=await api.put('/auth/profile',form);
      setUser(u=>({...u,...d}));
      setMsg(lang==='he'?'הפרטים עודכנו בהצלחה':'Profile updated successfully');
    }catch(e){setErr(e.message);}
    setLoading(false);
  };

  const savePassword=async()=>{
    setPwMsg('');setPwErr('');
    if(pwForm.new_password!==pwForm.confirm)return setPwErr(lang==='he'?'הסיסמאות לא תואמות':'Passwords do not match');
    if(pwForm.new_password.length<8)return setPwErr(lang==='he'?'סיסמה קצרה מדי (מינימום 8)':'Password too short (min 8)');
    setLoading(true);
    try{
      await api.put('/auth/password',{current_password:pwForm.current_password,new_password:pwForm.new_password});
      setPwMsg(lang==='he'?'הסיסמה שונתה בהצלחה':'Password changed successfully');
      setPwForm({current_password:'',new_password:'',confirm:''});
    }catch(e){setPwErr(e.message);}
    setLoading(false);
  };

  const back=()=>navigate(user?.role==='superadmin'||user?.role==='admin'?'/admin':'/moked');

  return(
    <div style={S.page}>
      <div style={{maxWidth:560,margin:'0 auto',padding:'32px 16px'}}>
        {/* Header */}
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:28}}>
          <button style={{...S.btn,...S.cancelBtn}} onClick={back}>
            {lang==='he'?'← חזרה':'← Back'}
          </button>
          <div style={{display:'flex',gap:8}}>
            <button onClick={()=>setLang(lang==='he'?'en':'he')} style={{...S.btn,padding:'6px 14px',fontSize:13,background:theme.card,color:theme.text,border:`1px solid ${theme.border}`}}>
              {lang==='he'?'EN':'עב'}
            </button>
            <button onClick={()=>setDark(!dark)} style={{...S.btn,padding:'6px 14px',fontSize:18,background:theme.card,border:`1px solid ${theme.border}`}}>
              {dark?'☀️':'🌙'}
            </button>
          </div>
        </div>

        {/* Avatar + info */}
        <div style={{...S.card,textAlign:'center'}}>
          <div style={{width:72,height:72,borderRadius:'50%',background:'#2563eb',display:'flex',alignItems:'center',justifyContent:'center',fontSize:28,color:'#fff',margin:'0 auto 12px'}}>
            {(user?.full_name||'?')[0]}
          </div>
          <div style={{fontSize:20,fontWeight:700,marginBottom:4}}>{user?.full_name}</div>
          <div style={{color:theme.subtext,fontSize:14,marginBottom:10}}>{user?.email}</div>
          <span style={S.badge}>{user?.role}</span>
          {user?.municipality&&<span style={{...S.badge,marginRight:8,background:'#6b7280'}}>{user.municipality}</span>}
        </div>

        {/* Edit profile */}
        <div style={S.card}>
          <div style={{fontSize:16,fontWeight:700,marginBottom:18}}>{lang==='he'?'עדכון פרטים':'Edit Profile'}</div>
          <label style={S.label}>{lang==='he'?'שם מלא':'Full Name'}</label>
          <input style={{...S.input,marginBottom:14}} value={form.full_name} onChange={e=>setForm(p=>({...p,full_name:e.target.value}))}/>
          <label style={S.label}>{lang==='he'?'טלפון':'Phone'}</label>
          <input style={{...S.input,marginBottom:18}} value={form.phone} onChange={e=>setForm(p=>({...p,phone:e.target.value}))}/>
          <button style={{...S.btn,...S.saveBtn}} onClick={saveProfile} disabled={loading}>
            {loading?'...':(lang==='he'?'שמור':'Save')}
          </button>
          {msg&&<div style={S.success}>{msg}</div>}
          {err&&<div style={S.error}>{err}</div>}
        </div>

        {/* Change password */}
        <div style={S.card}>
          <div style={{fontSize:16,fontWeight:700,marginBottom:18}}>{lang==='he'?'שינוי סיסמה':'Change Password'}</div>
          <label style={S.label}>{lang==='he'?'סיסמה נוכחית':'Current Password'}</label>
          <input style={{...S.input,marginBottom:14}} type="password" value={pwForm.current_password} onChange={e=>setPwForm(p=>({...p,current_password:e.target.value}))}/>
          <label style={S.label}>{lang==='he'?'סיסמה חדשה':'New Password'}</label>
          <input style={{...S.input,marginBottom:14}} type="password" value={pwForm.new_password} onChange={e=>setPwForm(p=>({...p,new_password:e.target.value}))}/>
          <label style={S.label}>{lang==='he'?'אימות סיסמה':'Confirm Password'}</label>
          <input style={{...S.input,marginBottom:18}} type="password" value={pwForm.confirm} onChange={e=>setPwForm(p=>({...p,confirm:e.target.value}))}/>
          <button style={{...S.btn,...S.saveBtn}} onClick={savePassword} disabled={loading}>
            {loading?'...':(lang==='he'?'שנה סיסמה':'Change Password')}
          </button>
          {pwMsg&&<div style={S.success}>{pwMsg}</div>}
          {pwErr&&<div style={S.error}>{pwErr}</div>}
        </div>
      </div>
    </div>
  );
}
